import { BookOpenTextIcon, ClipboardCheckIcon, ClipboardListIcon, FolderSearchIcon, MessagesSquareIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '150 Attività e Sfide di Scienze Forensi per la Classe',
    description: 'Attività pronte organizzate per tema, con obiettivo, durata, materiali semplici e sicuri e domande guida.',
    icon: ClipboardListIcon,
  },
  {
    number: '2',
    title: 'Banca di Verifiche e Valutazioni di Scienze Forensi',
    description: 'Verifiche per unità, soluzioni complete, griglie e rubriche di valutazione.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: '100 Casi di Studio e Scenari di Problem Solving',
    description: 'Casi fittizi da analizzare in classe, con prove, domande e soluzione ragionata.',
    icon: FolderSearchIcon,
  },
  {
    number: '4',
    title: 'Dizionario del Docente: 200 Concetti Essenziali',
    description: 'Definizioni semplici, spiegazioni per gli studenti, esempi ed errori comuni da evitare.',
    icon: BookOpenTextIcon,
  },
  {
    number: '5',
    title: '100 Sfide di Pensiero Critico e Discussione',
    description: "Dilemmi, domande sull'affidabilità delle prove e spunti di dibattito per la classe.",
    icon: MessagesSquareIcon,
  },
];
